var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("text-" + _vm.textAlign)},[_c('a',{class:("text-" + _vm.variant),attrs:{"href":_vm.defaultData.instagramLink,"target":"_blank"}},[_c('InstagramIcon',{staticClass:"mr-3",attrs:{"size":_vm.size}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }